//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            building: {},
            loading: false,
            structureTypes: [],
            buildingAddress: {},
            newAddress: {},
            addressesLoading: false,
            addressOptions: []
        };
    },


    methods: {
        saveBuilding: function saveBuilding() {
            var $el = this;
            this.loading = true;
            this.building.structure_category_id = this.building.structure_category.id;
            this.building.structure_type_id = this.building.structure_type.id;

            if (this.buildingAddress.id > 0) {
                this.building.property_address_id = this.buildingAddress.id;
            } else {
                this.building.property_address_id = null;
            }

            if (this.buildingAddress.id == -1) {
                this.building.newPropertyAddress = this.newAddress;
            }

            axios.patch('/prototype/buildings/' + $el.building.id, { building: this.building }).then(function (response) {
                if (response.data) {
                    $el.building = response.data;
                    $el.loading = false;
                    Event.$emit('buildings-updated');
                }
            });
        },
        getDropDownOptions: function getDropDownOptions() {
            this.loading = true;
            var $el = this;
            axios.get('/prototype/buildings/options').then(function (response) {
                if (response.data) {
                    $el.structureTypes = response.data.types;
                    $el.loading = false;
                }
            });

            axios.get('/prototype/properties/addresses').then(function (response) {
                if (response.data) {
                    //Add default dropdown options
                    $el.addressOptions = [{ address: 'Main Property Address', id: 0 }, { address: 'Add New', id: -1 }]; //probably a better way to do this

                    //Add loaded addresses on top of it
                    $el.addressOptions = $el.addressOptions.concat(response.data);

                    //Set the selected address to the proper option
                    if ($el.building.property_address_id) {
                        $el.buildingAddress = $el.addressOptions.find(function (x) {
                            return x.id === $el.building.property_address_id;
                        });
                    } else {
                        $el.buildingAddress = $el.addressOptions[0];
                    }

                    $el.addressesLoading = false;
                }
            });
        }
    },

    mounted: function mounted() {

        var $el = this;

        Event.$on('edit-building', function (item) {
            $el.building = item;
            Vue.nextTick().then(function () {
                $el.getDropDownOptions();
            });
            $el.$children[0].$data.showModal = true;
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/building/EditBuilding.vue
// module id = Sz0Z
// module chunks = 0 1